import React from 'react';
import { Preview } from '../../Preview';
import { InlineCropController } from './InlineCrop';
export const CropView = (props) => {
    const { Content, cacheStateKey, itemSelector, onChange } = props;
    return (React.createElement(Preview, { className: "crop-view", itemSelector: itemSelector, Content: Content }, (item, designRect) => (React.createElement(InlineCropController, { stateKey: cacheStateKey, crop: item.crop, designRect: Object.assign(Object.assign({}, designRect), { x: 0, y: 0 }), onChange: onChange }))));
};
